const mountTreatedDataRows = (
  dataOptions = [],
  dataTypesConfig = [],
  categoryKey = '',
) => {
  return dataOptions.map((item) => {
    const row = {
      name: item[categoryKey],
    }
    dataTypesConfig.forEach(({ key, id }) => {
      row[key] = item.dataTypes?.find((dt) => dt.dataType === id)?.quantity || 0
    })
    return row
  })
}

export default mountTreatedDataRows
